var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Terms and Conditions\n  "),(_vm.STATUS.LOADED)?_c('div',{staticClass:"LegalDocs--content"},[_vm._v("\n    "+_vm._s(_vm.compiledMarkdown)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }